// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__WPCVa","fileBtn":"File_fileBtn__2BUJp","closeBtn":"File_closeBtn__vj6lL","fileSelected":"File_fileSelected__1mlIO","disabled":"File_disabled__1TKHJ"};